import React, { useContext, useEffect, useState } from "react";
import { ContainerModalChaveIntegracao, MainContainerModalChaveIntegracao } from "./styles";
import { useTheme } from "../../../../contexts/Theme/ThemeContext";
import { ReactComponent as Arrow } from "../../../../assets/newImages/icons/arrowLeft.svg";
import { Button } from "../../../Button";
import { ToggleConfigurar } from "../../../Toggle/ToggleConfigurar/ToggleConfigurar";
import { EmpresaApi } from "../../../../hooks/empresaApi";
import Titulo from "../../../Titulo/Titulo";
import { Link } from "react-router-dom";
import { ConfiguracoesContext } from "../../../../contexts/Configuracoes/ConfiguracoesContext";
import { AuthContext } from "../../../../contexts/Auth/AuthContext";
import { PerfilApi } from "../../../../hooks/perfilApi";
import LoadingComFundo from "../../../Loading/LoadingComFundo/LoadingComFundo";
import LockedIcon from "../../../LockedIcon/LockedIcon";
import { EmpresaContext } from "../../../../contexts/Empresa/EmpresaContext";
import { Select } from "../../../Select";

interface ModalChaveIntegracaoProps {
  setModalOpen: (newValue: boolean) => void;
  onChange: (newValue: {
    chave: string;
    cadastrarProdutos: boolean;
    cadastrarImagens: boolean;
    cadastrarNivelSecundario: boolean;
    cadastrarSubcategoria: boolean;
    selecionarERP: string;
  }) => void;
}

const ModalChaveIntegracao: React.FC<ModalChaveIntegracaoProps> = ({
  setModalOpen,
  onChange,
}) => {
  const empresaApi = EmpresaApi();
  const { theme } = useTheme();
  const [etapa, setEtapa] = useState<number>(1);
  const {empresa} = useContext(EmpresaContext)
  const { permissoesPlanos } = useContext(AuthContext);
  const permite2Niveis = permissoesPlanos["ADICIONAR_VARIACAO_SECUNDARIA"]?.permitido;
  const permiteSubcategorias = permissoesPlanos["SUBCATEGORIAS"]?.permitido;
  const [configuracoes, setConfiguracoes] = useState<{
    cadastrarProdutos: boolean;
    cadastrarImagens: boolean;
    cadastrarNivelSecundario: boolean;
    cadastrarSubcategoria: boolean;
    selecionarERP: string;
  }>({
    cadastrarProdutos: false,
    cadastrarImagens: false,
    cadastrarNivelSecundario: false,
    cadastrarSubcategoria: false,
    selecionarERP: "",
  });
  const perfilApi = PerfilApi();
  const [loading, setLoading] = useState<boolean>(false);
  const [limiteLicencas, setLimiteLicencas] = useState<string>('');
  const [mostrarMensagem, setMostrarMensagem] = useState(false);
  const [erroERP, setErroERP] = useState(false);


  //AO ADICIONAR MAIS EMPRESAS ABAIXO, LEMBRAR TAMBÉM DE INCLUIR NO EMPRESAS > EDITAR.JS NO GERENCIAMENTO DO CONECTA
  const [opcoesRamosDeAtividades, setOpcoesRamosDeAtividades] = useState([
    { value: "Abacustec LTDA",         name: "Abacustec LTDA"                        },
    { value: "Brain-Wave Informática", name: "Brain-Wave Informática"                },
    { value: "DevMaster ERP",          name: "DevMaster ERP"                         },
    { value: "E-commerce da Macro",    name: "E-commerce da Macro"                   },
    { value: "Ferrari Sistemas",       name: "Ferrari Sistemas"                      },
    { value: "Forteplus Sistemas",     name: "Forteplus Sistemas"                    },
    { value: "GreenApp",               name: "GreenApp"                              },
    { value: "Ideall Sistemas",        name: "Ideall Sistemas"                       },
    { value: "Jueri",                  name: "Jueri"                                 },
    { value: "Outros",                 name: "Outros",                default: true  }
  ]);

  useEffect(() => {
    setLoading(true);
    const init = async () => {
      setLimiteLicencas(await perfilApi.verificaLimiteLicenca());
      setLoading(false);
    };
    init();
  }, []);

  const handleCriarChave = async () => {
    if (!configuracoes.selecionarERP) {
      setErroERP(true);
      return;
    }
    empresaApi
      .gerar_chave_api(
        configuracoes.cadastrarProdutos,
        configuracoes.cadastrarImagens,
        configuracoes.cadastrarNivelSecundario,
        configuracoes.cadastrarSubcategoria,
        configuracoes.selecionarERP,
      )
      .then((response) => {
        if (response) {
          onChange({
            chave: response,
            cadastrarProdutos: configuracoes.cadastrarProdutos,
            cadastrarImagens: configuracoes.cadastrarImagens,
            cadastrarNivelSecundario: configuracoes.cadastrarNivelSecundario,
            cadastrarSubcategoria: configuracoes.cadastrarSubcategoria,
            selecionarERP: configuracoes.selecionarERP,
          });
          setModalOpen(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <MainContainerModalChaveIntegracao>
      {loading ? (
        <LoadingComFundo />
      ) : (
        <>
          <Titulo
            title=""
            subtitle="Gerar chave via API"
          />
          {etapa === 1 && (
            <ContainerModalChaveIntegracao theme={theme}>
              <div className="texto">
                Ao gerar a chave será criado um novo usuário de integração na sua
                conta, gerando custos à sua mensalidade.
              </div>
              <div className="row-flex">
                <div
                  className="arrow"
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  <Arrow />
                  Voltar
                </div>
                {limiteLicencas !== 'LIMITE_USUARIOS' ? (
                  <Button
                    onClick={() => {
                      setEtapa(2);
                    }}
                    className="btn-salvar"
                    title={`${'Concordar e continuar'}`}
                    width="fit-content"
                  />
                ) : (
                  <Button 
                    title="Falar com o atendimento"
                    onClick={() => {
                      window.open(`https://api.whatsapp.com/send?phone=555434434563&text= Gostaria de gerar a chave da API.+Meu+usu%C3%A1rio+%C3%A9:+${empresa?.usuario}+da+empresa:+${empresa?.empresa}.`, "_blank")
                    }}
                  />
                )}
              </div>
            </ContainerModalChaveIntegracao>
          )}
          {etapa === 2 && (
            <ContainerModalChaveIntegracao theme={theme}>
              <div className="texto">
                Através da chave de API, a listagem dos pedidos é exibida diretamente em seu sistema.
                Você também pode cadastrar seus produtos e imagens, ativando as opções abaixo:
              </div>
              <div className="configs">
                <label className="config">
                  <ToggleConfigurar
                    onChange={(newValue) => {
                      setConfiguracoes({ ...configuracoes, cadastrarProdutos: newValue });
                    }}
                    value={configuracoes.cadastrarProdutos}
                  />
                  <div className="title">Produtos</div>
                </label>
                <label className="config">
                  <ToggleConfigurar
                    onChange={(newValue) => {
                      setConfiguracoes({ ...configuracoes, cadastrarImagens: newValue });
                    }}
                    value={configuracoes.cadastrarImagens}
                  />
                  <div className="title">Imagens</div>
                </label>
                <label className="config">
                  <ToggleConfigurar
                    onChange={(newValue) => {
                      if (!permite2Niveis) return;
                      setConfiguracoes({ ...configuracoes, cadastrarNivelSecundario: newValue });
                    }}
                    value={permite2Niveis ? configuracoes.cadastrarNivelSecundario : false}
                  />
                  <div className={`title${!permite2Niveis ? ' bloqueado' : ''}`}>Nível secundário de variação</div>
                  {!permite2Niveis && (
                    <LockedIcon
                      mensagem="Recurso disponível a partir do plano Essencial."
                      width="2.4rem"
                      className="locked-icon"
                    />
                  )}
                </label>
                <label className="config">
                  <ToggleConfigurar
                    onChange={(newValue) => {
                      if (!permiteSubcategorias) return;
                      setConfiguracoes({ ...configuracoes, cadastrarSubcategoria: newValue });
                    }}
                    value={permiteSubcategorias ? configuracoes.cadastrarSubcategoria : false}
                  />
                  <div className={`title${!permiteSubcategorias ? ' bloqueado' : ''}`}>Subcategoria</div>
                  {!permiteSubcategorias && (
                    <LockedIcon
                      mensagem="Recurso disponível a partir do plano Essencial."
                      width="2.4rem"
                      className="locked-icon"
                    />
                  )}
                </label>
                <div className="titulo_erp">
                  Selecione o ERP que irá utilizar:
                </div>
                <div className="linha">
                  <Select
                    placeholder="ERP"
                    className="selectApi"
                    options={opcoesRamosDeAtividades}
                    value={configuracoes.selecionarERP}
                    onChange={(newValue) => {
                      setConfiguracoes({ ...configuracoes, selecionarERP: newValue });
                      setMostrarMensagem(newValue === "Outros");
                      setErroERP(false);
                    }}
                    name={"ERP"}
                    required={true}
                    />
                  {erroERP && <span className="erro">Por favor, selecione uma opção.</span>}
                  {mostrarMensagem && (
                    <div className="mensagem_outros">
                      <a href="https://forms.gle/VcRspvUgQXZTdX7ZA" target="_blank">Acesse aqui</a> o formulário de homologação do ERP.    
                    </div>
                  )}
                </div>      
              </div>
              <div className="row-flex">
                <div
                  className="arrow"
                  onClick={() => {
                    setEtapa(1);
                  }}
                >
                  <Arrow />
                  Voltar
                </div>
                <Button
                  onClick={() => {
                    handleCriarChave();
                  }}
                  className="btn-salvar"
                  title={"Gerar chave"}
                  width="fit-content"
                />
              </div>
            </ContainerModalChaveIntegracao>
          )}
        </>
      )}
    </MainContainerModalChaveIntegracao>
  );
};

export default ModalChaveIntegracao;
